function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { asyncToGenerator as _asyncToGenerator } from "../_virtual/_rollupPluginBabelHelpers.js";
import _pt from 'prop-types';
import { useRef, useEffect, useState } from 'react';
import { jsx } from '@emotion/core';
import { Spinner } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import useStores from "../hooks/useStores.js";
import PdfPage from "./PdfPage.js";
import usePdfFile from "../hooks/api/usePdfFile.js";
import PdfDocumentStore from "../stores/PdfDocumentStore.js";
var PdfPages = observer(function (_ref) {
  var _pdfDocumentStore$tem, _pdfDocumentStore$tem2;

  var pdfDocumentStore = _ref.pdfDocumentStore;
  var ref = useRef(null);
  var id = pdfDocumentStore === null || pdfDocumentStore === void 0 ? void 0 : (_pdfDocumentStore$tem = pdfDocumentStore.template) === null || _pdfDocumentStore$tem === void 0 ? void 0 : _pdfDocumentStore$tem.id;
  var title = pdfDocumentStore === null || pdfDocumentStore === void 0 ? void 0 : (_pdfDocumentStore$tem2 = pdfDocumentStore.template) === null || _pdfDocumentStore$tem2 === void 0 ? void 0 : _pdfDocumentStore$tem2.name;
  useEffect(function () {
    if (!pdfDocumentStore) return;

    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var containerWidth, _ref$current, width, firstPageWidth, scale;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              containerWidth = pdfDocumentStore.pdfStore.pdfContainerWidth;

              if (!containerWidth) {
                width = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth;
                containerWidth = width;
                pdfDocumentStore.pdfStore.setPdfContainerWidth(width);
              }

              _context.next = 4;
              return pdfDocumentStore.documentProxy.getPage(1);

            case 4:
              firstPageWidth = _context.sent.getViewport({
                scale: 1
              }).width;
              scale = containerWidth / firstPageWidth;
              pdfDocumentStore.setBaseScale(scale - 0.025);
              pdfDocumentStore.setScale(scale - 0.025);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [pdfDocumentStore]);
  return jsx("div", {
    ref: ref
  }, jsx("div", {
    id: id ? "pdf-document-".concat(id) : '',
    className: "pt-2 pb-1 px-2 text-white"
  }, title ? "".concat(title, ".pdf") : ''), pdfDocumentStore === null || pdfDocumentStore === void 0 ? void 0 : pdfDocumentStore.pages.map(function (pageStore) {
    return jsx(PdfPage, {
      key: "pdfpage_".concat(pageStore.pageNumber),
      pageStore: pageStore
    });
  }));
});

var LoadingSpinner = function LoadingSpinner() {
  return jsx("div", {
    className: "text-center flex-grow-1 text-white-50 bg-dark pt-5"
  }, jsx(Spinner, {
    type: "spin",
    size: "25"
  }), jsx("h3", {
    className: "pt-1"
  }, "Loading PDF"));
};

LoadingSpinner.displayName = "LoadingSpinner";

var PdfDocument = function PdfDocument(_ref3) {
  var pdfFileLink = _ref3.pdfFileLink,
      annotationFields = _ref3.annotationFields,
      apiPrefixOverride = _ref3.apiPrefixOverride,
      template = _ref3.template,
      _ref3$index = _ref3.index,
      index = _ref3$index === void 0 ? 0 : _ref3$index;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore;

  var _usePdfFile = usePdfFile(),
      file = _usePdfFile.file,
      getPdfFile = _usePdfFile.getPdfFile,
      loading = _usePdfFile.loading;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      pdfDocumentStore = _useState2[0],
      setPdfDocumentStore = _useState2[1];

  useEffect(function () {
    getPdfFile({
      url: pdfFileLink,
      apiPrefixOverride: apiPrefixOverride
    });
  }, [pdfFileLink, apiPrefixOverride, getPdfFile]);
  useEffect(function () {
    if (pdfStore && file && annotationFields) {
      var store = pdfStore.documents.find(function (document) {
        return !!template && document.template === template;
      });

      if (store) {
        store.setIndex(index);
      } else {
        store = new PdfDocumentStore(pdfStore, file, index, annotationFields);
        setPdfDocumentStore(store);
      }
    }
  }, [pdfStore, file, index, annotationFields, template]);
  useEffect(function () {
    pdfDocumentStore === null || pdfDocumentStore === void 0 ? void 0 : pdfDocumentStore.setTemplate(template);
  }, [pdfDocumentStore, template]);
  return loading ? jsx(LoadingSpinner, null) : jsx(PdfPages, {
    pdfDocumentStore: pdfDocumentStore
  });
};

PdfDocument.propTypes = {
  pdfFileLink: _pt.string.isRequired,
  annotationFields: _pt.array.isRequired,
  apiPrefixOverride: _pt.string,
  index: _pt.number,
  children: _pt.node
};
var PdfDocument$1 = observer(PdfDocument);
export default PdfDocument$1;
export { LoadingSpinner, PdfPages };